import React, { useEffect, useState } from 'react';
import CustomerRatingRanking from './CustomerRatingRanking';
import { EmployeesProvider } from 'src/scenes/Rankings/hooks/useEmployees';
import useDeal from 'src/hooks/api/useDeal';

const CustomerRatingRankingContainer = ({}) => {
  const [startDateFilter, setStartDateFilter] = useState<string>();
  const [endDateFilter, setEndDateFilter] = useState<string>();
  const [employeesStats, setEmployeesStats] = useState<
    { employeeId: string; averageRating: number; ratingCount: number }[]
  >([]);
  const { getEmployeesDealAverageRatings } = useDeal();

  const handleChangeDateFilter = (startDate?: string, endDate?: string) => {
    setStartDateFilter(startDate);
    setEndDateFilter(endDate);
  };

  useEffect(() => {
    getEmployeesDealAverageRatings(startDateFilter, endDateFilter).then((response) => {
      setEmployeesStats(response);
    });
  }, [startDateFilter, endDateFilter]);

  return (
    <EmployeesProvider>
      <CustomerRatingRanking
        onChangeDateFilter={handleChangeDateFilter}
        startDateFilter={startDateFilter}
        endDateFilter={endDateFilter}
        employeesStats={employeesStats}
      />
    </EmployeesProvider>
  );
};

export default CustomerRatingRankingContainer;
